// Unified Color Scheme for Dashboard Charts
// This ensures consistency across all visualizations

export const DASHBOARD_COLORS = {
  // Sector Colors (Primary categories)
  sectors: {
    food: {
      primary: '#ef4444',      // Red-500
      light: 'rgba(239, 68, 68, 0.6)',
      background: 'rgba(239, 68, 68, 0.1)'
    },
     FOOD: {
      primary: '#ef4444',      // Red-500
      light: 'rgba(239, 68, 68, 0.6)',
      background: 'rgba(239, 68, 68, 0.1)'
    },
    power: {
      primary: '#ef4444',      // Red-500
      light: 'rgba(239, 68, 68, 0.6)',
      background: 'rgba(239, 68, 68, 0.1)'
    },
    residential: {
      primary: '#3b82f6',      // Blue-500
      light: 'rgba(59, 130, 246, 0.6)',
      background: 'rgba(59, 130, 246, 0.1)'
    },
    buildings: {
      primary: '#3b82f6',      // Blue-500
      light: 'rgba(59, 130, 246, 0.6)',
      background: 'rgba(59, 130, 246, 0.1)'
    },
     BUILDINGS: {
      primary: '#3b82f6',      // Blue-500
      light: 'rgba(59, 130, 246, 0.6)',
      background: 'rgba(59, 130, 246, 0.1)'
    },
    RES: {
      primary: '#3b82f6',      // Blue-500
      light: 'rgba(59, 130, 246, 0.6)',
      background: 'rgba(59, 130, 246, 0.1)'
    },
    transport: {
      primary: '#f59e0b',      // Amber-500
      light: 'rgba(245, 158, 11, 0.6)',
      background: 'rgba(245, 158, 11, 0.1)'
    },
     fossil: {
      primary: '#f59e0b',      // Amber-500
      light: 'rgba(245, 158, 11, 0.6)',
      background: 'rgba(245, 158, 11, 0.1)'
    },
     TRA: {
      primary: '#f59e0b',      // Amber-500
      light: 'rgba(245, 158, 11, 0.6)',
      background: 'rgba(245, 158, 11, 0.1)'
    },
    industry: {
      primary: '#10b981',      // Emerald-500
      light: 'rgba(16, 185, 129, 0.6)',
      background: 'rgba(16, 185, 129, 0.1)'
    },
     biofuels: {
      primary: '#10b981',      // Emerald-500
      light: 'rgba(16, 185, 129, 0.6)',
      background: 'rgba(16, 185, 129, 0.1)'
    },
         bioenergy: {
      primary: '#10b981',      // Emerald-500
      light: 'rgba(16, 185, 129, 0.6)',
      background: 'rgba(16, 185, 129, 0.1)'
    },
    IND: {
      primary: '#10b981',      // Emerald-500
      light: 'rgba(16, 185, 129, 0.6)',
      background: 'rgba(16, 185, 129, 0.1)'
    },



  },


  // Energy Technology Colors
  energy: {
    // --- VECTORS used by SectorEnergyVectorChart ---
    electricity: {
      primary: '#2563eb',      // Blue-600
      light: 'rgba(37, 99, 235, 0.35)'
    },
     fossil: {
      primary: '#ef4444"',      // Blue-600
      light: 'rgba(239,68,68,1)'
    },
     interconnector: {
      primary: '#3b82f6',      // Blue-500
      light: 'rgba(59, 130, 246, 0.6)',
      background: 'rgba(59, 130, 246, 0.1)'
    },
     hydrogen: {
      primary: '#10b981',      // Emerald-500
      light: 'rgba(16, 185, 129, 0.6)',
    },
    onshoreWind: {
      primary: '#06b6d4',      // Cyan-500
      light: 'rgba(6, 182, 212, 0.35)'
    },
    beccs: {
      primary: '#ef4444',      // Red-500
      light: 'rgba(239, 68, 68, 0.35)'
    },
    gas: {
      primary: '#a855f7',      // Purple-500
      light: 'rgba(168, 85, 247, 0.30)'
    },
    offshoreWind: {
      primary: '#1e40af',      // Blue-800
      light: 'rgba(30, 64, 175, 0.6)'
    },
    solar: {
      primary: '#f59e0b',      // Amber-500
      light: 'rgba(245, 158, 11, 0.6)'
    },
    tidal: {
      primary: '#0891b2',      // Cyan-600
      light: 'rgba(8, 145, 178, 0.6)'
    },
    hydro: {
      primary: '#7c3aed',      // Violet-600
      light: 'rgba(124, 58, 237, 0.6)'
    },
    biomass: {
      primary: '#ea580c',      // Orange-600
      light: 'rgba(234, 88, 12, 0.6)'
    },
    biofuels: {
  primary: '#f59e0b',      // Amber-500
      light: 'rgba(245, 158, 11, 0.6)',
      background: 'rgba(245, 158, 11, 0.1)'
    },
    //      bioenergy: {
    //   primary: '#10b981',      // Emerald-500
    //   light: 'rgba(16, 185, 129, 0.6)',
    //   background: 'rgba(16, 185, 129, 0.1)'
    // },
    nuclearMicroPlants: {
      primary: '#dc2626',      // Red-600
      light: 'rgba(220, 38, 38, 0.6)'
    },
    nuclear: {
      primary: '#dc2626',      // Red-600
      light: 'rgba(220, 38, 38, 0.6)'
    }
  },

  // Net Zero Balance Colors
  netZero: {
    energyDemand: {
      primary: '#3b82f6',      // Blue-500
      light: 'rgba(59, 130, 246, 0.6)'
    },
    emissions: {
      primary: '#ef4444',      // Red-500
      light: 'rgba(239, 68, 68, 0.6)'
    },
    greenEnergy: {
      primary: '#22c55e',      // Green-500
      light: 'rgba(34, 197, 94, 0.6)'
    },
    carbonRemoval: {
      primary: '#8b5cf6',      // Violet-500
      light: 'rgba(139, 92, 246, 0.6)'
    }
  },

  // Abatement Pathway Colors (Optimized for color blind accessibility)
  abatement: {
    remaining: {
      primary: '#1f2937',      // Very Dark Gray - High contrast
      light: 'rgba(31, 41, 55, 0.6)'
    },
    engineeredRemovals: {
      primary: '#7c3aed',      // Violet-600 - Distinct purple
      light: 'rgba(124, 58, 237, 0.2)'
    },
    'Carbon dioxide removals': {
      primary: '#7c3aed',      // Violet-600 - Distinct purple
      light: 'rgba(124, 58, 237, 0.2)'
    },
    natureBased: {
      primary: '#059669',      // Emerald-600 - Clear green
      light: 'rgba(5, 150, 105, 0.2)'
    },
    lowCarbonFuels: {
      primary: '#dc2626',      // Red-600 - Clear red
      light: 'rgba(220, 38, 38, 0.2)'
    },
    electricityDecarb: {
      primary: '#0284c7',      // Sky-600 - Clear blue
      light: 'rgba(2, 132, 199, 0.6)'
    },
    Electrification: {
      primary: '#0284c7',      // Sky-600 - Clear blue
      light: 'rgba(2, 132, 199, 0.6)'
    },
    energyEfficiency: {
      primary: '#ea580c',      // Orange-600 - Bright orange
      light: 'rgba(234, 88, 12, 0.6)'
    },
    'Energy demand reduction': {
      primary: '#ea580c',      // Orange-600 - Bright orange
      light: 'rgba(234, 88, 12, 0.6)'
    },
  },

  // Neutral/Supporting Colors
  neutral: {
    baseline: {
      primary: '#6b7280',      // Gray-500
      light: 'rgba(107, 114, 128, 0.6)'
    },
    target: {
      primary: '#374151',      // Gray-700
      light: 'rgba(55, 65, 81, 0.6)'
    }
  }
};

// Helper functions to get colors
export const getSectorColor = (sector, variant = 'primary') => {
  return DASHBOARD_COLORS.sectors[sector]?.[variant] || DASHBOARD_COLORS.neutral.baseline[variant];
};

export const getEnergyColor = (technology, variant = 'primary') => {
  return DASHBOARD_COLORS.energy[technology]?.[variant] || DASHBOARD_COLORS.neutral.baseline[variant];
};

export const getNetZeroColor = (component, variant = 'primary') => {
  return DASHBOARD_COLORS.netZero[component]?.[variant] || DASHBOARD_COLORS.neutral.baseline[variant];
};

export const getAbatementColor = (component, variant = 'primary') => {
  return DASHBOARD_COLORS.abatement[component]?.[variant] || DASHBOARD_COLORS.neutral.baseline[variant];
};
